import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { FilePreviewer } from "./Components/FilePreviewer";
import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";

export const Files = () => {
  const { selectedObject } = useStorageSelectors("userfiles");
  const { handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  if (selectedObject?.value === null) {
    return (
      <>
        <NoObjectChosen
          message={t("userfiles.no_object_message")}
          folderName={selectedObject.friendly_name}
          onClick={() => handleOpenModal("upload_file_method_modal", null)}
        />
      </>
    );
  }
  return (
    <>
      <FilePreviewer />
    </>
  );
};
